export const statusInitialColors = {
	morningShift: '#79abda',
	noonShift: '#517fa8',
	nightShift: '#264c6d',
	onCall: '#daa479',
	unassigned: '#e0e0e0',
	dayOff: '#fff',
};
